import SolutionsDigitalSupplyChain from 'components/SolutionsDigitalSupplyChain/SolutionsDigitalSupplyChain'
import '../SolutionsPage.css'

const DigitalSupplyChain = () => {
  return (
    <div>
      <SolutionsDigitalSupplyChain />
    </div>
  )
}

export default DigitalSupplyChain
